import React, { useState } from "react";
import useDocumentList from "../../hooks/useDocumentList";
import InvoiceDataGrid from "./InvoiceDataGrid";
import InvoiceActivityLogs from "./InvoiceActivityLogs";
import DocumentHeader from "./DocumentHeader";
import { useNavigate } from "react-router-dom";
import LogisticsActivityTimeline from "./LogisticsActivityTimeline";

const DoLogisticList = () => {
  const [p1Value, setP1Value] = useState("ALL");
  const [modalType, setModalType] = useState(null);
  const navigate = useNavigate();

  const {
    config,
    searchTerm,
    setSearchTerm,
    searchType,
    setSearchType,
    showSidebar,
    setShowSidebar,
    columnVisibilityModel,
    setColumnVisibilityModel,
    documentData,
    columns,
    rows,
    selectionModel,
    setSelectionModel,
    selectedRowData,
    setSelectedRowData,
    loading,
    handleEdit,
    exportDocumentList,
    handleView,
    pageNumber,
    setPageNumber,
    currentEnd,
    currentStart,
    totalCount,
    refreshDocumentList,
  } = useDocumentList({
    docType: "DORDLOGISTICS",
    docLabel: "Delivery Order",
    p1Value,
    p2Value: "-",
    docNoField: "DO NO",
    editRoute: "/delivery_order",
    screenCode: "DOLOGICOUNT",
    initialSearchType: "-",
  });

  const handleExport = () => {
    exportDocumentList();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <DocumentHeader
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        BASE_URL={config.BASE_URL}
        COMPANY_CODE={config.COMPANY_CODE}
        DEPARTMENT={config.DEPARTMENT_NO}
        title={"Orders for Delivery"}
        searchTerm={searchTerm}
        searchType={searchType}
        setSearchTerm={setSearchTerm}
        setSearchType={setSearchType}
        filteredDocs={documentData}
        showType={p1Value}
        setShowType={setP1Value}
        total={totalCount}
        onExport={handleExport}
        // onPrint={handlePrint}
        documentType={"LOGISTICLIST"}
        config={config}
        selectedRowData={selectedRowData}
        doctype="DO NO"
        showFilter={false}
        showPrint={false}
        showActivitySidebar={true}
      />
      <div className="max-w-full mx-auto py-2 space-y-4">
        <div className="grid grid-cols-12 gap-4">
          {showSidebar && (
            <LogisticsActivityTimeline
              BASE_URL={config.BASE_URL}
              COMPANY_CODE={config.COMPANY_CODE}
              DEPARTMENT={config.DEPARTMENT_NO}
              referenceId={selectedRowData["DO NO"]}
              activityType={"DOLOGITIMELINE"}
            />
          )}
          <div
            className={`col-span-12 ${
              showSidebar ? "lg:col-span-9" : "lg:col-span-12"
            } transition-all duration-300`}
          >
            <InvoiceDataGrid
              rows={rows}
              columns={columns}
              loading={loading}
              selectionModel={selectionModel}
              setSelectionModel={setSelectionModel}
              setSelectedRowData={setSelectedRowData}
              selectedRowData={selectedRowData}
              onEdit={handleEdit}
              onView={handleView}
              columnVisibilityModel={columnVisibilityModel}
              setColumnVisibilityModel={setColumnVisibilityModel}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              currentStart={currentStart}
              currentEnd={currentEnd}
              totalCount={totalCount}
              showSidebar={showSidebar}
              docLabel={"DO"}
              enableF5Action={false}
              config={config}
              refreshDocumentList={refreshDocumentList}
              f5Mode={"DOSETTLEMENT"}
              modalType="close"
              setModalType={setModalType}
              showEdit={false}
              showSchedule={true}
              onSchedule={() => {
                navigate("#delivery_schedule", {
                  state: {
                    doNumber: selectedRowData["DO NO"],
                  },
                });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoLogisticList;
